import { useId } from 'react';

import { MathText } from '@/features/content/MathText';

import styles from './EquationEditor.module.css';

interface EquationEditorProps {
  onChange: (latex: string) => void;
  value?: string;
}

export function EquationEditor({
  onChange,
  value = '',
}: EquationEditorProps) {
  const inputId = useId();

  return (
    <div className={styles.root}>
      <label className={styles.label} htmlFor={inputId}>
        LaTeX equation
      </label>
      <textarea
        className={styles.textarea}
        id={inputId}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        placeholder="\frac{F}{m}"
        rows={6}
        value={value}
      />

      <div className={styles.preview}>
        <p className={styles.previewLabel}>Preview</p>
        <div className={styles.previewSurface}>
          {value.trim().length > 0 ? (
            <MathText text={`$$${value.trim()}$$`} />
          ) : (
            <span className={styles.placeholder}>
              Add LaTeX to preview the equation block.
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
